module.exports = __webpack_public_path__ + "img/20200318113401071.502f530f.png";